var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/buildify-view-mode-wrapper.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { ContextProvider, createContext } from "@lit/context";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { Contexts } from "./globals/enums.js";
var BuildifyViewModeWrapper = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._modeProvider = new ContextProvider(this, {
      context: createContext(Contexts.MODE)
    });
  }
  updated() {
    this._modeProvider.setValue("view", true);
  }
  render() {
    return html` <slot></slot> `;
  }
};
BuildifyViewModeWrapper = __decorateClass([
  customElement("buildify-view-mode-wrapper")
], BuildifyViewModeWrapper);
export {
  BuildifyViewModeWrapper
};
